export default __webpack_public_path__ + "static/banner-real-stories-saving-spending-lending-amin-2fdf4f2aab5792d0345ff48adea64581.jpg";